import axiosInstance from "../config/axios.config";

export const getAdmissionReportAPI = (facility, date) => {
  if (facility && date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/admissions-report/?facility=${facility}&start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/admissions-report/?start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (facility) {
    return axiosInstance.get(
      `/billing/dashboard/admissions-report/?facility=${facility}`
    );
  } else {
    return axiosInstance.get(`/billing/dashboard/admissions-report/`);
  }
};

export const getAdmissionAnalyticsAPI = (filter, facility) => {
  if (facility) {
    return axiosInstance.get(
      `/billing/dashboard/admission-analytics/?range=${filter}&facility=${facility}`
    );
  } else {
    return axiosInstance.get(
      `/billing/dashboard/admission-analytics/?range=${filter}`
    );
  }
};

export const getFinancialMetricsAPI = (facility, date) => {
  if (facility && date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/financial-metrics/?facility=${facility}&start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/financial-metrics/?start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (facility) {
    return axiosInstance.get(
      `/billing/dashboard/financial-metrics/?facility=${facility}`
    );
  } else {
    return axiosInstance.get(`/billing/dashboard/financial-metrics/`);
  }
};

export const getFinancialAnalyticsAPI = (filter, facility) => {
  if (facility) {
    return axiosInstance.get(
      `/billing/dashboard/financial-analytics/?range=${filter}&facility=${facility}`
    );
  } else {
    return axiosInstance.get(
      `/billing/dashboard/financial-analytics/?range=${filter}`
    );
  }
};

export const getBedAndBillsReportAPI = (facility, date) => {
  if (facility && date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `billing/dashboard/bed-and-bills-report/?facility=${facility}&start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/bed-and-bills-report/?start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (facility) {
    return axiosInstance.get(
      `billing/dashboard/bed-and-bills-report/?facility=${facility}`
    );
  } else {
    return axiosInstance.get(`billing/dashboard/bed-and-bills-report/`);
  }
};

export const getBedOccupancyAnalyticsAPI = (filter, facility) => {
  if (facility) {
    return axiosInstance.get(
      `billing/dashboard/bed-occupancy-analytics/?range=${filter}&facility=${facility}`
    );
  } else {
    return axiosInstance.get(
      `billing/dashboard/bed-occupancy-analytics/?range=${filter}`
    );
  }
};

export const getArpobReportsAPI = (facility, date) => {
  if (facility && date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `billing/dashboard/arpob-reports/?facility=${facility}&start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (date?.start_date && date?.end_date) {
    return axiosInstance.get(
      `/billing/dashboard/arpob-reports/?start_date=${date?.start_date}&end_date=${date?.end_date}`
    );
  } else if (facility) {
    return axiosInstance.get(
      `billing/dashboard/arpob-reports/?facility=${facility}`
    );
  } else {
    return axiosInstance.get(`billing/dashboard/arpob-reports/`);
  }
};

export const getArpobAnalyticsAPI = (filter, facility) => {
  if (facility) {
    return axiosInstance.get(
      `billing/dashboard/arpob-analytics/?range=${filter}&facility=${facility}`
    );
  } else {
    return axiosInstance.get(
      `billing/dashboard/arpob-analytics/?range=${filter}`
    );
  }
};

export const getIPReportAPI = (facility, date, page, pageSize, search, reportType) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", pageSize);

  if (facility) params.append("facility", facility);
  if (date?.start_date && date?.end_date) {
    params.append("start_date", date.start_date);
    params.append("end_date", date.end_date);
  }

if (reportType) params.append("report_type", reportType);
  if (search) params.append("search", search);

  return axiosInstance.get(
    `/billing/dashboard/ip-report/?${params.toString()}`
  );
};

export const getOPReportAPI = (facility, date, page, pageSize, search) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("page_size", pageSize);

  if (facility) params.append("facility", facility);

  if (date?.start_date && date?.end_date) {
    params.append("start_date", date.start_date);
    params.append("end_date", date.end_date);
  }

  if (search) params.append("search", search);

  return axiosInstance.get(
    `/billing/dashboard/op-report/?${params.toString()}`
  );
};


export const getIPFinalDischargeReportAPI = (
  facilityId,
  date,
  page,
  limit,
  search
) => {
  const params = new URLSearchParams();

  if (date?.from_date && date?.to_date) {
    params.append("from_date", date.from_date);
    params.append("to_date", date.to_date);
  }

  if (facilityId) params.append("facility_id", facilityId);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);

  return axiosInstance.get(
    `/billing/dashboard/ip-final-discharge-report/?${params.toString()}`
  );
};

export const getOperationsReportAPI = (
  reportType,
  facility,
  date,
  page,
  pageSize,
  search
) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("page_size", pageSize);

  if (facility) params.append("facility", facility);
  if (date?.start_date && date?.end_date) {
    params.append("start_date", date.start_date);
    params.append("end_date", date.end_date);

    params.append("search", search); // only when both dates exist
  }

  return axiosInstance.get(
    `/billing/dashboard/${reportType}/?${params.toString()}`
  );
};

